import { render } from "./download.vue?vue&type=template&id=ee85dad2&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=ee85dad2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ee85dad2"

export default script